import Component from '@glimmer/component';
import type { ComponentLike } from '@glint/template';
import type { Args } from 'parog-web/components/medical-history/abstract/base-edition-form';
import MedicalHistoryCardio from 'parog-web/components/medical-history/cardio';
import MedicalHistoryDiabeto from 'parog-web/components/medical-history/diabeto';
import MedicalHistoryDigest from 'parog-web/components/medical-history/digest';
import MedicalHistoryGeneric from 'parog-web/components/medical-history/generic';
import MedicalHistoryHepato from 'parog-web/components/medical-history/hepato';
import MedicalHistoryMental from 'parog-web/components/medical-history/mental';
import MedicalHistoryNephro from 'parog-web/components/medical-history/nephro';
import MedicalHistoryOnco from 'parog-web/components/medical-history/onco';
import MedicalHistoryPneumo from 'parog-web/components/medical-history/pneumo';

interface Signature {
  Args: Args;
}

const AreaComponents = {
  cardio: MedicalHistoryCardio,
  diabeto: MedicalHistoryDiabeto,
  digest: MedicalHistoryDigest,
  generic: MedicalHistoryGeneric,
  hepato: MedicalHistoryHepato,
  mental: MedicalHistoryMental,
  nephro: MedicalHistoryNephro,
  onco: MedicalHistoryOnco,
  pneumo: MedicalHistoryPneumo
};

export default class MedicalHistoryComponent extends Component<Signature> {
  get areaComponent(): ComponentLike<Signature> | undefined {
    if (!this.args.patient.followUpReasonRecord) return;

    const area = this.args.patient.followUpReasonRecord.therapeuticalArea.id;
    return AreaComponents[area];
  }

  <template>
    {{#if this.areaComponent}}
      <this.areaComponent
        @patient={{@patient}}
        @sourceJeId={{@sourceJeId}}
        @isReadOnly={{@isReadOnly}}
        @afterCompleted={{@afterCompleted}}
        @afterCancel={{@afterCancel}}
        @formAction={{@formAction}}
      />
    {{/if}}
  </template>
}
